export const Package_Order_Interval = 5 * 1000 * 60;
export const Max_Order_Show_Num = 10;
export const Lazy_Img_Src = 'https://mcombo.meituan.net/test/hotel/ebooking/images/003.gif';
export const Lazy_Load_Attr = 'data-src';


// WEBPACK FOOTER //
// ./src/config/packageProduct.js